interface LogoProps {
  className?: string;
  size?: number;
  title?: string;
}

const QikServeLogo: React.FC<LogoProps> = ({
  className,
  size = 36,
  title = 'QikServe',
}) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 36 36'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
    role='img'
    aria-label={title}
  >
    <rect width='36' height='36' rx='8' fill='currentColor' />
    <text
      x='50%'
      y='50%'
      dominantBaseline='central'
      textAnchor='middle'
      fontFamily='Inter Variable, sans-serif'
      fontWeight='700'
      fontSize='14'
      fill='#ffffff'
    >
      Q
    </text>
  </svg>
);

export default QikServeLogo;
